//this page is for showing all the customers
import React, { useState } from "react";
import SideMenu from "../../components/organisms/sidebar";
import LoggedHeader from "../Common/loggedHeader";
import { Table, Select, MenuItem, Menu, TextField, Button, IconButton, Collapse, Box, Grid, InputAdornment } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { formatter } from '../Common/commonUtils';
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { LIST_USERS } from "../../Graphql/queries";
import { DELETE_CUSTOMER } from "../../Graphql/mutations";
import Pagination from "@mui/material/Pagination";
import DialogBox from "../Common/dialogBox";
import { toggleSnackbar,authVar } from "../../ReactiveVariables/index";
import Stack from "@mui/material/Stack";
import EditCustomerProfile from "./CustomerListDetails/editProfile";
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ClearIcon from '@mui/icons-material/Clear';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function CustomerList() {
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [openProfile, setOpenProfile] = useState(false);
  const [page, setPage] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedItem,setSelectedItem] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalCustomerCount, setTotalCustomerCount] = useState(0);
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  // Sorting state
  const [sortField, setSortField] = useState("totalSpend");
  const [sortOrder, setSortOrder] = useState("desc");
  
  // Filter states
  const [showFilters, setShowFilters] = useState(false);
  const [minTotalSpend, setMinTotalSpend] = useState("");
  const [maxTotalSpend, setMaxTotalSpend] = useState("");
  const [minOrderCount, setMinOrderCount] = useState("");
  const [maxOrderCount, setMaxOrderCount] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  
  // Handle sorting
  const handleSort = (field) => {
    if (sortField === field) {
      // Toggle sort order if same field is clicked
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Set new field and default to ascending
      setSortField(field);
      setSortOrder("asc");
    }
    setPage(1); // Reset to first page when sorting changes
  };
  
  // Get sort icon for column
  const getSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortOrder === "asc" ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />;
  };
  
  // Clear all filters
  const clearFilters = () => {
    setMinTotalSpend("");
    setMaxTotalSpend("");
    setMinOrderCount("");
    setMaxOrderCount("");
    setFromDate(null);
    setToDate(null);
    setPage(1);
  };
  
  // Apply filters
  const applyFilters = () => {
    setPage(1);
  };
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }
  const navigate = useNavigate()
  const customerVariables = {
    userType: "Customer",
    limit: rowsPerPage,
    skip: (page - 1) * rowsPerPage,
    search: search,
    sortField: sortField || undefined,
    sortOrder: sortOrder || undefined,
    minTotalSpend: minTotalSpend ? parseFloat(minTotalSpend) : undefined,
    maxTotalSpend: maxTotalSpend ? parseFloat(maxTotalSpend) : undefined,
    minOrderCount: minOrderCount ? parseInt(minOrderCount) : undefined,
    maxOrderCount: maxOrderCount ? parseInt(maxOrderCount) : undefined,
    fromDate: fromDate || undefined,
    toDate: toDate || undefined,
  };
  // Query for all customers (no filters) to get total count
  const { data: totalData } = useQuery(LIST_USERS, {
    variables: {
      userType: "Customer",
      limit: 1,
      skip: 0
    },
    onCompleted: (data) => {
      if (data?.listUser?.count) {
        setTotalCustomerCount(data.listUser.count);
      }
    }
  });
  
  // Query for filtered customers
  const { data, loading } = useQuery(LIST_USERS, {
    variables: customerVariables,
  });
  const [deleteCustomer]= useMutation(DELETE_CUSTOMER,{refetchQueries:['ListUser']})
  const handleChangePage = (e, pages) => {
    setPage(pages);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  function handlePageInputChange(event) {
    setRowsPerPage(Number(event.target.value));
    setPage(1);
  }
  //customer delete function
  function handleDelete(){
    try { deleteCustomer({ variables: {customerId: selectedItem?._id } })
        .then((res) => {
          toggleSnackbar({
            status: true,
            message: "Customer deleted successfully",
            variant: 'success'
          });
        })
        .catch((err) => {
          const message = err && err.message
          if(message==="Not authenticated"){
            localStorage.clear();
            authVar({
              loaded: true,
              auth: false,
            });
            navigate("/admin", { state: "noAuth" })
          }else{
          toggleSnackbar({
            status: true,
            message: message,
            variant: "error",
          });
        }
        });
      } catch (err) {
        const message = err && err.message;
        toggleSnackbar({
          status: true,
          message: message,
          variant: "error",
        });
      }
  }
  return (
    <div>
      {openProfile && <EditCustomerProfile
      openProfile={openProfile}
      setOpenProfile={setOpenProfile}
      selectedItem={selectedItem}
      setSelectedItem= {setSelectedItem}
        />}
      {openDialog && (<DialogBox
        setOpenDialog={setOpenDialog}
        handleDelete={handleDelete}
        openDialog={openDialog}
        title="Delete"
        discription="Are you sure you want to delete this customer?"
      />
      )}
      <LoggedHeader title="Customers" user="admin" />
      <SideMenu selected="Customers" user="admin" />
      <div className="contentWrap">
        <div className="contentWrapInner">
          <div className="location-head">
            <div className="location-head-title justify-content-between">
              { data?.listUser?.count !== undefined ? 
                <h5>
                  {`${data?.listUser?.count} Customer${data?.listUser?.count !== 1 ? 's' : ''}`}
                  {(minTotalSpend || maxTotalSpend || minOrderCount || maxOrderCount || fromDate || toDate) && 
                    totalCustomerCount > 0 && data?.listUser?.count !== totalCustomerCount ? 
                    ` (Filtered from ${totalCustomerCount} total)` : ''
                  }
                </h5> 
                : <p>Loading...</p>
              }
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  placeholder="Search by Customer Name"
                  className="form-control"
                  value={search}
                  onChange={(e) => {
                    setPage(1);
                    setSearch(e.target.value);
                  }}
                />
                <IconButton 
                  color={showFilters ? "primary" : "default"} 
                  onClick={() => setShowFilters(!showFilters)}
                  style={{ marginLeft: '10px' }}
                >
                  <FilterListIcon />
                </IconButton>
              </div>
            </div>
            
            {/* Filter Panel */}
            <Collapse in={showFilters}>
              <Box sx={{ p: 2, mt: 2, border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <h6 style={{ margin: 0 }}>Filters</h6>
                      <Button 
                        variant="outlined" 
                        size="small" 
                        onClick={clearFilters}
                        startIcon={<ClearIcon />}
                      >
                        Clear All
                      </Button>
                    </Box>
                  </Grid>
                  
                  {/* Total Spend Filter */}
                  <Grid item xs={12} md={4}>
                    <h6>Total Spend</h6>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <TextField
                        label="Min"
                        type="number"
                        size="small"
                        value={minTotalSpend}
                        onChange={(e) => setMinTotalSpend(e.target.value)}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        sx={{ mr: 1, width: '45%' }}
                      />
                      <TextField
                        label="Max"
                        type="number"
                        size="small"
                        value={maxTotalSpend}
                        onChange={(e) => setMaxTotalSpend(e.target.value)}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        sx={{ width: '45%' }}
                      />
                      <Button 
                        variant="contained" 
                        size="small" 
                        onClick={applyFilters}
                        sx={{ ml: 1 }}
                      >
                        Apply
                      </Button>
                    </Box>
                  </Grid>
                  
                  {/* Order Count Filter */}
                  <Grid item xs={12} md={4}>
                    <h6>Order Count</h6>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <TextField
                        label="Min"
                        type="number"
                        size="small"
                        value={minOrderCount}
                        onChange={(e) => setMinOrderCount(e.target.value)}
                        sx={{ mr: 1, width: '45%' }}
                      />
                      <TextField
                        label="Max"
                        type="number"
                        size="small"
                        value={maxOrderCount}
                        onChange={(e) => setMaxOrderCount(e.target.value)}
                        sx={{ width: '45%' }}
                      />
                      <Button 
                        variant="contained" 
                        size="small" 
                        onClick={applyFilters}
                        sx={{ ml: 1 }}
                      >
                        Apply
                      </Button>
                    </Box>
                  </Grid>
                  
                  {/* Sign-up Date Filter */}
                  <Grid item xs={12} md={4}>
                    <h6>Sign-up Date</h6>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label="From"
                          value={fromDate}
                          onChange={(newValue) => setFromDate(newValue)}
                          renderInput={(params) => <TextField {...params} size="small" sx={{ mr: 1, width: '45%' }} />}
                        />
                        <DatePicker
                          label="To"
                          value={toDate}
                          onChange={(newValue) => setToDate(newValue)}
                          renderInput={(params) => <TextField {...params} size="small" sx={{ width: '45%' }} />}
                        />
                      </LocalizationProvider>
                      <Button 
                        variant="contained" 
                        size="small" 
                        onClick={applyFilters}
                        sx={{ ml: 1 }}
                      >
                        Apply
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          </div>
          <TableContainer>
            <Table
              className="commonTabel"
              sx={{ minWidth: 650 }}
              aria-label="simple table"
            >
              <TableHead>
                <TableRow>
                  <TableCell 
                    onClick={() => handleSort("name")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      Customer Name {getSortIcon("name")}
                    </div>
                  </TableCell>
                  <TableCell 
                    align="left"
                    onClick={() => handleSort("email")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      Email {getSortIcon("email")}
                    </div>
                  </TableCell>
                  <TableCell 
                    align="center"
                    onClick={() => handleSort("createdDate")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      Sign up Date {getSortIcon("createdDate")}
                    </div>
                  </TableCell>
                  <TableCell align="center">Phone</TableCell>
                  <TableCell 
                    align="center"
                    onClick={() => handleSort("orderCount")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      Orders {getSortIcon("orderCount")}
                    </div>
                  </TableCell>
                  <TableCell 
                    align="center"
                    onClick={() => handleSort("totalSpend")}
                    style={{ cursor: 'pointer' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      Total Spend {getSortIcon("totalSpend")}
                    </div>
                  </TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p> Loading...</p>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : data && data?.listUser?.data?.length > 0 ? (
                  data &&
                  data?.listUser?.data?.map((item) => (
                    <TableRow style={{ cursor: "pointer" }}>
                      <TableCell component="th" scope="row" onClick={() => navigate(`${item?._id}`)}>
                        {item?.name}
                      </TableCell>
                      <TableCell align="left" onClick={() => navigate(`${item?._id}`)}>{item?.email}</TableCell>
                      <TableCell align="center">{new Date(item?.createdDate).toLocaleDateString('en-US',options)}</TableCell>
                      <TableCell align="center">{item?.phoneNumber}</TableCell>
                      <TableCell align="center">{item?.orderCount}</TableCell>
                      <TableCell align="center">{formatter.format(item?.totalSpend)}</TableCell>
                      <TableCell align="center">
                        <img
                          style={{ cursor: "pointer" }}
                            onClick={(e) => { setSelectedItem(item); handleClick(e) }}
                          src="../assets/images/more-horizontal.svg"
                          alt="img"
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : search ? (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p>No data Found</p>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <p>No list added Yet!</p>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="table-pagenation">
          <div className="rowCount">
            <Select
              onChange={handlePageInputChange}
              value={rowsPerPage}
            >
              <MenuItem value={10}>{10}</MenuItem>
              <MenuItem value={25}>{25}</MenuItem>
              <MenuItem value={50}>{50}</MenuItem>
              <MenuItem value={100}>{100}</MenuItem>
            </Select>
          </div>

          <Stack spacing={2}>
            <Pagination
              className="tableCount"
              count={Math.ceil(data?.listUser?.count / rowsPerPage)}
              variant="outlined"
              shape="rounded"
              page={page}
              onChange={handleChangePage}
            />
          </Stack>
        </div>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          className="menu-list-more"
        >
        <MenuItem onClick={() => { navigate(`${selectedItem?._id}`);handleClose() }}>View</MenuItem>
          <MenuItem
            onClick={() => {
              setOpenProfile(true);
              handleClose();
            }}
          >
            Edit
          </MenuItem>
          <MenuItem onClick={() => { setOpenDialog(true); handleClose() }}>Delete</MenuItem>
        </Menu>
      </div>
    </div>
  );
}
